import { render, staticRenderFns } from "./AbandonedCartNotificationConfig.vue?vue&type=template&id=8da1f45a&scoped=true&"
import script from "./AbandonedCartNotificationConfig.vue?vue&type=script&lang=js&"
export * from "./AbandonedCartNotificationConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da1f45a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8da1f45a')) {
      api.createRecord('8da1f45a', component.options)
    } else {
      api.reload('8da1f45a', component.options)
    }
    module.hot.accept("./AbandonedCartNotificationConfig.vue?vue&type=template&id=8da1f45a&scoped=true&", function () {
      api.rerender('8da1f45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/AbandonedCartNotification/AbandonedCartNotificationConfig.vue"
export default component.exports